export default function Pin(props) {
    const fill = props.fill ?? '#212121';

    return (
        <svg
            width="27"
            height="28"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
        >
            <path
                d="M23 10L27 19H16V25L11 28V19H0L4 10V1.66893e-06L23 0V10Z"
                fill={fill}
            />
        </svg>
    );
}
